/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { polarisSettingsDatesRoute } from '@jira/router-routes__polaris-routes/src/polarisSettingsDatesRoute.tsx';
import { polarisProductDatesSettingsPageEntryPoint } from './ui/settings/dates/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const polarisSettingsDatesRouteEntry: Route = createEntry(polarisSettingsDatesRoute, () => ({
	isStrictModeEnabled: false,
	group: 'global-settings',
	layout: globalSettingsLayout,

	navigation: {
		sidebarId: SidebarIdGlobalProductsSettings,
		menuId: MenuIdSettings,
	},

	resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

	entryPoint() {
		return polarisProductDatesSettingsPageEntryPoint;
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
